<!-- <sf-smartquote-nav></sf-smartquote-nav> -->
<sf-page-title
    title="Smart Quotes"
    icon="file-invoice-dollar"
    description="Manage and review all Smart Quotes generated within Surequote. Smart Quotes allow you to create detailed quotes for your customers, ensuring transparency and professionalism in your service offerings."
    docUrl="https://surefire-software.gitbook.io/docs/" />
<sf-smartquote-search
    [existingFilter]="smartQuoteHelperService.filter()"
    (onSearchClicked)="onFilterChange($event)"></sf-smartquote-search>

<sf-card>
    @if (smartQuotesPaged(); as quotesPaged) {
        @if (quotesPaged.items.length) {
            <sf-smartquote-table [smartQuotes]="quotesPaged.items"></sf-smartquote-table>

            <div class="mt-3">
                <sf-pagination-detail
                    [paginationData]="quotesPaged"
                    (onPageChange)="onPageChange($event)"></sf-pagination-detail>
            </div>
        } @else {
            <sf-empty
                message="There are no Smart Quotes to show, change your query parameters and try again."></sf-empty>
        }
    }
</sf-card>

<sf-page-action-bar>
    <button sfButton type="button" color="success" icon="plus" (click)="openCustomerPullout()">Create</button>
</sf-page-action-bar>
